import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-brand-name-modal',
  templateUrl: './brand-name-modal.component.pug',
  styleUrls: ['./brand-name-modal.component.scss'],
  standalone: false
})
export class BrandNameModalComponent extends AbstractModalComponent implements OnInit {

  @Input() brand_name!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = { 'brand_name': this.brand_name };

  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.orgDetails["brand_name"] = this.orgDetails["brand_name"].trim();
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid || this.orgDetails["brand_name"] === "") {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  getForm() {
    return this.orgForm;
  }

}
